<template>
  <div class="detail">
    <VCarousel/>
    <DetailTabs @clickTab="handleClickTab"/>
    <template v-if="activeTab === 'product'">
      <Advantage :isShowBtn="false" bgcolor="#ebf0fa"/>
      <Article :content="easy"/>
      <Article :content="best" bgcolor="#ebf0fa"/>
    </template>
    <template v-if="activeTab === 'video'">
      <VideosBlock title="产品演示" subTitle="Product demonstration" bgcolor="#ebf0fa" :videos="showHowVideos"/>
      <!-- <VideosBlock title="入门教程" subTitle="Introductory tutorial"/>
      <VideosBlock title="进阶教程" subTitle="Advanced tutorial" bgcolor="#ebf0fa"/> -->
    </template>
  </div>
</template>
<script>
import VCarousel from '@/components/VCarousel.vue'
import DetailTabs from '@/components/DetailTabs.vue'
import Advantage from '@/components/Advantage.vue'
import Article from '@/components/Article.vue'
import VideosBlock from '@/components/VideosBlock.vue'
import best from '@/md/best.md'
import easy from '@/md/easy.md'
import { showHowVideos } from '@/config/types.config'


export default {
  components: {
    VCarousel,
    DetailTabs,
    Advantage,
    Article,
    VideosBlock
  },
  data() {
    return {
      best,
      easy,
      activeTab: 'product',
      showHowVideos
    }
  },
  methods: {
    handleClickTab(item) {
      this.activeTab = item
    }
  }
}
</script>
